import clsx from 'clsx';
// mantine
import { MantineSize } from '@mantine/core';

interface NoRecordsProps {
    children?: React.ReactNode;
    size?: MantineSize;
}

const NoRecords = ({ children, size = 'sm' }: NoRecordsProps) => {
    return (
        <div
            className={clsx(
                'flex items-center justify-center py-16 text-gray-6',
                `text-${size}`
            )}
        >
            {children ?? 'No records found'}
        </div>
    );
};

export default NoRecords;
